// extracted by mini-css-extract-plugin
export default {"btnScrollToUpHidden":"goToTopButton_btnScrollToUpHidden__XVAsX","btnScrollToUp":"goToTopButton_btnScrollToUp__2WvRy"};